
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ProcessAssignToScenarioPayload = {
  orderIds: EntityId[]
  scenarioId: EntityId
}

export const processAssignToScenario = createAsyncThunk<void, ProcessAssignToScenarioPayload, { state: RootState }>(
  'dragdrop/processAssignToScenario',
  async ({ orderIds, scenarioId }) => {
    await OLMSApiService.post<null>('/planning/assignToScenario', {
      orderIds: orderIds,
      scenarioId: scenarioId,
    })
  },
)
